<template>
  <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-2 tw-transition-all">
    <slot />
  </div>
</template>
